import React from 'react';
import Caption from '../Form/Caption';

export const requestCaption = (
    <Caption wide offsetTop>
        В&nbsp;данной форме можно запросить доступ до&nbsp;определенного продавца. Оплаты можно проводить в&nbsp;пользу
        только тех продавцов, для которых подтвержден доступ.
    </Caption>
);

export const requestTokenCaption = <span>Токен можно получить у&nbsp;продавца</span>;

export const requestDescriptionCaption = <span>Небольшое сопроводительное описание к&nbsp;запросу</span>;

export const publicKeyCaption = (
    <span>
        Публичный ключ потребуется для проверки подлинности запросов с&nbsp;оплатой. Значение ключа закодировано в
        base64.
    </span>
);

export const merchantsTableCaption = (
    <span>
        Список продавцов, к&nbsp;которым отправлен запрос на&nbsp;предоставление доступа. После подтверждения запроса
        поле &laquo;Статус&raquo; изменится на&nbsp;&laquo;Подтвержден&raquo;.
    </span>
);
